"use client";
import { useState } from "react";
import { createPortal } from "react-dom";
import { Copyright } from "lucide-react";

function LicenseTab() {
  const [isVisible, setIsVisible] = useState(false);

  const model = (
    <div className="license-overlay" onClick={() => setIsVisible(false)}>
      <div
        className="license-model-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => setIsVisible(false)}
          className="close-btn license-close-button"
        >
          ✕
        </button>

        <h3 className="license-title"> License Information</h3>
        
        <h4 className="license-subheading">Vehicle Data</h4>
        <p className="license-body-text">
          Contains information licensed under the{" "} 
          <a 
            href="https://open.canada.ca/en/open-government-licence-canada" 
            target="_blank" 
            rel="noopener noreferrer">
            Open Government Licence – Canada
          </a>.
        </p>
        <ul className="vehicle-reference-list tight-list">
          <li>
            <em>
              <a 
                href="https://open.canada.ca/data/en/dataset/98f1a129-f628-4ce4-b24d-6f16bf24dd64/resource/42495676-28b7-40f3-b0e0-3d7fe005ca56" 
                target="_blank" 
                rel="noopener noreferrer">
                Fuel Consumption Ratings (1995–2014)
              </a>
            </em>
          </li>
          <li>
            <em>
              <a 
                href="https://open.canada.ca/data/en/dataset/98f1a129-f628-4ce4-b24d-6f16bf24dd64/resource/505e609e-624c-443f-9155-97431e5e3732" 
                target="_blank" 
                rel="noopener noreferrer">
                Fuel Consumption Ratings (2015–2024)
              </a>
            </em>
          </li>
        </ul>

        {/* <h4 className="license-subheading">Map Data</h4>
        <p className="license-body-text">
          This service uses{" "}
          <a href="https://openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">
            OpenStreetMap (OSM)
          </a>{" "}
          data licensed under the{" "}
          <a href="https://opendatacommons.org/licenses/odbl/1-0/" target="_blank" rel="noopener noreferrer">
            Open Database License (ODbL)
          </a> and is served by{" "}
          <a href="https://www.geofabrik.de/geofabrik/index.html" target="_blank" rel="noopener noreferrer">
            Geofabrik GmbH
          </a>.
        </p>

        <h4 className="license-subheading">Route Data</h4>
        <p className="license-body-text">
          This service uses {" "}
          <a href="https://project-osrm.org/" target="_blank" rel="noopener noreferrer">
            Open Source Routing Machine (OSRM)
          </a> 
          {" "} for routing, which is licensed under the{" "}
          <a href="https://opensource.org/license/bsd-2-clause" target="_blank" rel="noopener noreferrer">
            2-Clause BSD License
          </a>.<br />
          Source code:{" "}
          <a href="https://github.com/Project-OSRM" target="_blank" rel="noopener noreferrer">
            https://github.com/Project-OSRM
          </a>.<br /><br />

          Copyright (c) 2017, Project OSRM contributors<br />
          All rights reserved.
        </p>

        <h4 className="license-subheading">Geocode Data</h4>
        <p className="license-body-text">
          This service uses{" "}
          <a href="https://nominatim.openstreetmap.org/ui/about.html" target="_blank" rel="noopener noreferrer">
            Nominatim
          </a>
          {" "}for geocoding, which is licensed under the{" "}
          <a href="https://www.gnu.org/licenses/old-licenses/gpl-2.0.en.html#SEC4" target="_blank" rel="noopener noreferrer">
            GNU General Public License, version 2
          </a>.
        </p> */}

        <h4 className="license-subheading">Map Data</h4>
        <p className="license-body-text">
          This service uses{" "}
          <a href="https://openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">
            OpenStreetMap (OSM)
          </a>{" "}
          data licensed under the{" "}
          <a href="https://opendatacommons.org/licenses/odbl/1-0/" target="_blank" rel="noopener noreferrer">
            Open Database License (ODbL)
          </a>.
        </p>

        <h4 className="license-subheading">Routes Data</h4>
        <p className="license-body-text">
          This service uses {" "}
          <a href="https://openrouteservice.org/" target="_blank" rel="noopener noreferrer">
            Open Route Service (ORS)
          </a> 
          {" "} for routing, which is licensed under the{" "}
          <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">
            CC-BY 4.0
          </a> 
          {" "}license agreement. See ORS{" "}
          <a href="https://openrouteservice.org/terms-of-service/#/attribution" target="_blank" rel="noopener noreferrer">
            Terms of Service
          </a>
          {" "}for more information.
        </p>

        <h4 className="license-subheading">Geocode Data</h4>
        <p className="license-body-text">
          This service uses {" "}
          <a href="https://openrouteservice.org/" target="_blank" rel="noopener noreferrer">
            Open Route Service (ORS)
          </a> 
          {" "} for geocode results, which uses the open source{" "}
          <a href="https://github.com/pelias/pelias" target="_blank" rel="noopener noreferrer">
            Pelias geocoder
          </a> and is licensed under the{" "}
          <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">
            CC-BY 4.0
          </a> 
          {" "}license agreement. See ORS{" "}
          <a href="https://openrouteservice.org/terms-of-service/#/attribution" target="_blank" rel="noopener noreferrer">
            Terms of Service
          </a>
          {" "}for more information.
        </p>
          

        <h4 className="license-subheading">Emission Data</h4>

        <h4 className="license-subsubheading">Food Data</h4>
        <p className="license-emission-body-text license-body-text">
          Food emission data provided by Poore and Nemecek (2018): Reducing food&apos;s environmental impacts through producers and consumers. <em>Science</em> 360 987-992 (2018). DOI: 10.1126/science.aaq0216.
          Original paper and data available{" "}
          <a href="https://www.science.org/doi/10.1126/science.aaq0216" target="_blank" rel="noopener noreferrer">
            here
          </a>.
          This data is provided for personal and educational use only. 
          You may not use this data for commercial purposes, including but not limited to resale, redistribution,
          {" "}or integration into a paid product or service. See <em>Science</em>{" "}
          <a href="https://www.science.org/content/page/terms-service" target="_blank" rel="noopener noreferrer">
            Terms of Service
          </a> for more details.
        </p>

        <h4 className="license-subsubheading">Transport Data</h4>
        <p className="license-emission-body-text license-body-text">
          Transportation emission data provided by{" "}
          <em>
            UK Government, Department of Energy Security and Net Zero (2025)
          </em>.
          Data available{" "}
          <a href="https://www.gov.uk/government/publications/greenhouse-gas-reporting-conversion-factors-2025" target="_blank" rel="noopener noreferrer">
            here
          </a>
          {" "}under the{" "}
          <a href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/" target="_blank" rel="noopener noreferrer">
            Open Government License for public sector information
          </a>.
        </p>

        {/* <h4 className="license-subsubheading">Appliance Data</h4>
        <p className="license-emission-body-text license-body-text">
          Electrical appliance data was calculated by assuming an average CO2 emission per kilowatt of power from coal / gas power stations.
          Weisser, Daniel. "A guide to life-cycle greenhouse gas (GHG) emissions from electric supply technologies." <em>Energy</em> 32.9 (2007) 1543-1559.
          Power generation emissions - Weisser, Daniel. "A guide to life-cycle greenhouse gas (GHG) emissions from electric supply technologies." Energy 32.9 (2007) 1543-1559. Appliance power consumption -https://www.electricalsafetyfirst.org.uk/guidance/safety-around-the-home/home-appliances-ratings/
          This was combined with power consumptions of common household appliances, taken from{" "}
          <a href="https://www.electricalsafetyfirst.org.uk/guidance/safety-around-the-home/home-appliances-ratings/" target="_blank" rel="noopener noreferrer">
            Electrical Safety First
          </a>.
          Values will vary depending on the actual CO2 emission from power generation method and appliance power rating.
        </p> */}

        <h4 className="license-subheading">Icons</h4>
        <p className="license-body-text">
          Map marker from{" "}
          <a href="https://www.reshot.com/free-svg-icons/item/map-marker-TDJ2KX5LNA/" target="_blank" rel="noopener noreferrer">
            Reshot
          </a>
          {" "}under the{" "}
          <a href="https://www.reshot.com/license/" target="_blank" rel="noopener noreferrer">
            Reshot Stock Icon Free License
          </a>.
          All other icons from{" "}
          <a href="https://lucide.dev/license" target="_blank" rel="noopener noreferrer">
            Lucide
          </a>.
        </p>

      </div>
    </div>
  );

  return (
    <>
      <div className="license-button-container">
        <button
          onClick={() => setIsVisible(true)}
          className="button license-button"
        >
          <Copyright size={25}/>
        </button>
      </div>

      {isVisible && createPortal(model, document.body)}
    </>
  );
}

export default LicenseTab;
